module.exports = __webpack_public_path__ + "36c93ba5371025c55e2463d580f5dd84.svg";